type TaskPreviewVisibilityInput = {
  loading: boolean;
  error?: boolean;
  taskCount: number;
  totalCount: number;
};

export function shouldShowTaskPreviewSection({
  loading,
  error = false,
  taskCount,
  totalCount
}: TaskPreviewVisibilityInput): boolean {
  return loading || error || taskCount > 0 || totalCount > 0;
}

type TodoPanelVisibilityInput = {
  canViewTasks: boolean;
  tasksLoading: boolean;
  tasksError?: boolean;
  taskCount: number;
  totalOpenTaskCount: number;
  teamTasksLoading?: boolean;
  teamTasksError?: boolean;
  teamTaskCount?: number;
  totalOpenTeamTaskCount?: number;
  showChangeRequestsSection: boolean;
};

export function shouldShowTodoPanel({
  canViewTasks,
  tasksLoading,
  tasksError = false,
  taskCount,
  totalOpenTaskCount,
  teamTasksLoading = false,
  teamTasksError = false,
  teamTaskCount = 0,
  totalOpenTeamTaskCount = 0,
  showChangeRequestsSection
}: TodoPanelVisibilityInput): boolean {
  if (showChangeRequestsSection) {
    return true;
  }

  if (!canViewTasks) {
    return false;
  }

  return (
    shouldShowTaskPreviewSection({
      loading: tasksLoading,
      error: tasksError,
      taskCount,
      totalCount: totalOpenTaskCount
    }) ||
    shouldShowTaskPreviewSection({
      loading: teamTasksLoading,
      error: teamTasksError,
      taskCount: teamTaskCount,
      totalCount: totalOpenTeamTaskCount
    })
  );
}

export function getTodoPanelDescription({
  showMyTasks,
  showTeamTasks,
  showChangeRequestsSection
}: {
  showMyTasks: boolean;
  showTeamTasks: boolean;
  showChangeRequestsSection: boolean;
}): string | null {
  const subjects: string[] = [];
  if (showMyTasks) subjects.push("your assigned tasks");
  if (showTeamTasks) subjects.push("team tasks");
  if (showChangeRequestsSection) subjects.push("pending change requests");
  if (subjects.length === 0) return null;
  if (subjects.length === 1) return `Review ${subjects[0]} below.`;
  if (subjects.length === 2) return `Review ${subjects[0]} and ${subjects[1]} below.`;
  return `Review ${subjects[0]}, ${subjects[1]}, and ${subjects[2]} below.`;
}
